module.exports = "/static/media/glyphicons-halflings-regular.e18bbf61.ttf";